export default "__VITE_ASSET__54c60b7f__"